import { render, staticRenderFns } from "./deleteShopCoupon.vue?vue&type=template&id=521bdf78"
import script from "./deleteShopCoupon.vue?vue&type=script&lang=js"
export * from "./deleteShopCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports